'use client';
import { useState, useEffect, useRef } from 'react';
import '@/styles/components/ui/menu.css';

const Menu = () => {
  const [menu, toggleMenu] = useState(false);
  const btnRef = useRef(null);
  const mainContentRef = useRef(null);

  useEffect(() => {
    mainContentRef.current = document.getElementById('main-main');
  }, []);

  const menuState = () => {
    const isOpen = document.body.classList.contains('viewing');

    if (isOpen) {
      document.body.classList.add('closing');
      document.body.classList.remove('viewing');
      setTimeout(() => document.body.classList.remove('closing'), 300);
      mainContentRef.current?.removeAttribute('inert');
    } else {
      document.body.classList.add('viewing');
      mainContentRef.current?.setAttribute('inert', '');
    }
    toggleMenu(!menu);
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && document.body.classList.contains('viewing')) {
        btnRef.current?.click();
      }
    };

    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <button
      ref={btnRef}
      onClick={menuState}
      className="menu"
      aria-controls="main-menu"
      aria-expanded={menu}
    >
      Menu
    </button>
  );
};

export default Menu;
